import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getLenis } from "@/components/SmoothScroll";

// Resets scroll to the top on every route change.
// Goes through Lenis (which hijacks window scrolling) so the reset is not
// overridden by an in-flight smooth-scroll animation. Hash links (#section)
// are left alone so anchor navigation still works.
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    const lenis = getLenis();
    if (lenis) {
      lenis.scrollTo(0, { immediate: true, force: true });
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};
